import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowSmallUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	fill: "none",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M19.027 28 17.5 26.478 24 20l6.5 6.478L28.973 28 24 23.055 19.027 28z",
		clipRule: "evenodd"
	})
});
export default SvgIconArrowSmallUp;
